import { Toolbar, Box, CssBaseline} from '@mui/material';
import { useContext, useState } from 'react';

import { Header } from './Header';
import { DrawerAdmin } from './DrawerAdmin';
import { BodyDashRouters } from '../routers/BodyDashRouters';
import { AuthContext } from '../auth/authContext';
import { Form } from '../pages/welcomeScreen/Form';


export default function DashboardContent() {
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const { user } = useContext(AuthContext)

  return (
    <Box sx={{ display: 'flex' }} >
      <CssBaseline />
      <Header open={open} toggleDrawer={toggleDrawer} />
      <DrawerAdmin open={open} toggleDrawer={toggleDrawer} />
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          width: '100%',
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />
        {/* {Acá va el body} */}
        {user.updatePass === 'config' ? <Form /> : <BodyDashRouters />}
      </Box>
    </Box>

  );
}